import { StationeryProduct } from '@shared/utils/print-price/types';

export const getPossibleOptions = (product: StationeryProduct, attributeId: string): string[] => {
  const attributes = product.attributes;
  const targetAttribute = attributes.find(attr => attr.attributeId === attributeId);

  if (!targetAttribute) {
    return [];
  }

  return targetAttribute.attributeOptions.map(opt => opt.attributeOption.id);
};
